import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18n from 'i18next';

import {
  selectActiveType,
  selectAmount,
  selectBalance,
  selectPaymentMethod,
} from '@cashier/cashier-data-access';
import { PaymentTypes } from '@cashier/cashier-model';

import {
  getAmountScaleValidationError,
  validateByCharactersType,
  validateByLimits,
} from '../helpers';

export const useAmountValidationErrors = (): string[] => {
  const method = useSelector(selectPaymentMethod);
  const amount = useSelector(selectAmount);
  const balance = useSelector(selectBalance);
  const paymentType = useSelector(selectActiveType);

  const { t } = useTranslation();

  const errors = [];

  if (!amount) return errors;

  if (!validateByCharactersType(amount)) {
    errors.push(i18n.t('amountCharactersInvalid.message'));

    return errors;
  }

  const { ruleParams } = method;
  const { min, max } = ruleParams || {};

  if (!validateByLimits(amount, min, max)) {
    const limitsMessageMapper = {
      [PaymentTypes.Deposit]: t('minMaxValidationFailed.deposit.message'),
      [PaymentTypes.Withdrawal]: t('minMaxValidationFailed.withdrawal.message'),
    };

    const message = limitsMessageMapper[paymentType];
    message && errors.push(message);
  }

  const amountScaleValidationError = getAmountScaleValidationError(
    method,
    amount,
  );

  if (amountScaleValidationError) {
    errors.push(amountScaleValidationError);
  }

  if (PaymentTypes.Withdrawal === paymentType) {
    if (balance && Number(balance) < Number(amount.replace(',', '.'))) {
      errors.push(i18n.t('insufficientFunds.message'));
    }
  }

  return errors;
};
